const Loading = ({message}) => {
  return (
    <div className="dreamfox-loading">{message}</div>
  )
}

export default Loading;